import React from 'react'
import {Box} from 'grommet'
import CreateOrgForm from '../../../components/createOrgForm'
import {Storage,API,Auth} from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { NavigationSnackBar } from '../../../components/utils/shared/shared';
import { withRouter } from 'react-router';

class CreateOrg extends React.Component {

    state = {
        load: false,
        value: {name: '', logo_key: ''},
        documents: null,
        key: uuidv4(),
        organisationSucc: false
    }

    handleValueChange = (event) => {
        this.setState({value: event});
      };

      handleDocsChange = (event) => {
        this.setState({documents: event.target.files[0]})
      };

      uploadToS3 = (files) => {
          console.log(files)
        const file = files
        const fileName = files.name
        Storage.put(`${this.state.key}/${fileName}`,file, {
          contentType: 'image/png'
        })
        .then (result => {
          console.log(result)
        }) 
        .catch(err => console.log(err));
      }

    handleSubmit = () => {
        const organisation = this.state.value
        this.setState({load: true})
        if (this.state.documents != null){
            this.uploadToS3(this.state.documents)
            organisation.logo_key = this.state.key
          }
          Auth.currentSession().then(session => {
            API
            .post("LabShip", "/organisations",
            { headers: { 
              Authorization: session.idToken.jwtToken,
            }, 
            body:{organisation: organisation}})
           .then(shipment => {
           this.setState({load: false})
           this.props.history.push({pathname: "/admin/organisations/all", edit:false, organisationSucc:true})
         })
        })
      }
    
    render(){
        const {load,value} = this.state;
        return ( 
          <Box>
            <NavigationSnackBar title={"Create Organisation"} user={this.props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Organisations', link: '/organisations/all'}]}  />
            <Box direction='row' justify="center" flex="grow">
                <CreateOrgForm handleSubmit={this.handleSubmit} handleChange={this.handleValueChange} value={value} load={load} handleDocsChange={this.handleDocsChange}/>
            </Box>
            </Box>
          )
    }
}

export default withRouter(CreateOrg)
